import React from 'react'

import { Dialog } from 'primereact/dialog'
import DialogFooter from '../dialogFooter'
import { Button } from 'primereact/button'
import GeneralServices from '../../app/service/generalServices'
import HandleErrorService from '../../app/service/handleErrorService'
import * as popUp from '../toastr'
import ConstantsUtil from '../../context/constantsUtil'
import TipoDreCompetenciaService from '../../app/service/contasAPagar/tipoDreCompetenciaService'
import TipoDreCompetenciaTable from './tipoDreCompetenciaTable'
import CreateOrUpdateTipoDreCompetenciaDialog from './createOrUpdateTipoDreCompetenciaDialog'

class ChooseTipoDreCompetenciaDialog extends React.Component {

    constructor(){
        super()
        this.generalServices = new GeneralServices();
        this.tipoDreCompetenciaService = new TipoDreCompetenciaService()
        this.dt = React.createRef()
    }

    state = {

        selectedTipoDreCompetencia: '',
        tipoDreCompetenciaList: [],

        displayCadastroDialog: false,

        didUpdated: false,

        loading: false,

    }

    componentDidUpdate(){
        if(!this.props.waitToDidMount){
            this.setStates()
        }
    }

    setStates = () => {
        if( (this.props.visible && !this.state.didUpdated) || this.props.forceUpdate ){

            var list = []
            this.setState({tipoDreCompetenciaList: list})
            this.setState({selectedTipoDreCompetencia: ''})
            if( !this.props.isFromGrupoDePagamentoTable && (!this.props.list || this.props.list.length === 0) ){
                //NÃO recebeu lista via props.
                // this.autoSearch()
            }
            else {
                //Recebeu lista via props.
                list = this.props.list
                this.setState({tipoDreCompetenciaList: list})
                if(!this.state.loading){
                    /*
                    Às vezes, o dialog abre antes de a lista ser passada como prop. Daí entra no autosearch
                    Neste caso, deixa abrir o dropdown do filtro por lá.
                    */
                    GeneralServices.callAbrirFiltroNome(ConstantsUtil.tipoColunaNomeFiltro, 500)
                }
            }

            if(this.props.doneForceUpdate){
                this.props.doneForceUpdate()
            }
            this.setState({didUpdated: true})

        }
    }

    autoSearch = () => {
        this.autoSearchWithSearchFunction(this.tipoDreCompetenciaService.search())
    }

    autoSearchWithSearchFunction = (searchFunction) => {

        this.setState({loading: true})

        searchFunction
        .then(response => {
            const list = response.data
            this.setState({tipoDreCompetenciaList: list})
            GeneralServices.callAbrirFiltroNome(ConstantsUtil.tipoColunaNomeFiltro, 300);
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally( () => {
            this.setState({loading: false})
        } )        
    }

    callSave = async () => {
        
        if(this.state.selectedTipoDreCompetencia){
            this.save(this.state.selectedTipoDreCompetencia)
            return
        }

        const list = JSON.parse(JSON.stringify(this.state.tipoDreCompetenciaList))
        if(list.length === 1){
            this.save(list[0])
        }
        else{
            popUp.infoPopUp("Selecione um Tipo DRE Competência.")
        }
    }

    search = () => {
        this.dt.current.search()
    }

    handleSelectionTipoDreCompetenciaChange = async (value) => {
        await this.generalServices.sleep(100)
        if(
            this.state.selectedTipoDreCompetencia
            && value === null
            && !this.dt.current.isEditDialogOpen()
            && !this.dt.current.isDeleteDialogOpen()
        ){ //significa que clicou em cima do Tipo de Recebimento que estava selecionado antes (double click).
            this.callSave()
        } else{ //vem aqui no 1° clique.
            this.setState({selectedTipoDreCompetencia: value})
        }
    }

    hideDialog = () => {
        this.props.hideDialog()
        this.setState({didUpdated: false})
    }

    hideCadastroDialog = () => {
        this.setState({displayCadastroDialog: false})
    }

    save = async (selectedTipoDreCompetencia) => {
        if(!selectedTipoDreCompetencia){
            return
        }
        await this.props.handleSelectionTipoDreCompetenciaChange(selectedTipoDreCompetencia)
        this.hideDialog()
    }

    render () {

        const dialogFooter = (
            <DialogFooter save = {this.callSave} hideDialog = {this.hideDialog} disabled={this.props.disabled}/>
        )

        const renderCadastrarButton = () => {
            if(!this.props.simpleView){
                return (
                    <>
                        <Button
                            label="Cadastrar"
                            icon="pi pi-plus"
                            onClick = {() => this.setState({displayCadastroDialog: true})}
                            style={ {maxWidth: '200px' } }
                        />

                        <br />

                        <br />                    
                    </>
                )
            }
        }

        return (
            <>
            <Dialog 
                visible={this.props.visible}
                style={{ width: '70vw' }}
                header={this.props.header}
                modal
                className="p-fluid"
                footer={dialogFooter}
                onHide={this.hideDialog}
            >

                {renderCadastrarButton()}

                <TipoDreCompetenciaTable
                    ref={this.dt}
                    list = {this.state.tipoDreCompetenciaList}
                    searchText={this.state.searchText}
                    selectable
                    loading = {this.state.loading}
                    handleSelectionChange={this.handleSelectionTipoDreCompetenciaChange}
                    emptyMessage="Não há Tipos de Pagamento Associados"
                />

                <CreateOrUpdateTipoDreCompetenciaDialog
                    visible={this.state.displayCadastroDialog}
                    search={this.search}
                    hideDialog={this.hideCadastroDialog}
                />


            </Dialog>
            </>
        )
    }

}

export default ChooseTipoDreCompetenciaDialog